import { css } from "@emotion/react";

import { getSpaceVariable } from "../../../components/space/utilities";
import Text from "../../../components/Text";
import { OnMouseOver } from "../../../layouts/SupportZone/constants";
import SpecialSupport from "../../../layouts/SupportZone/SpecialSupport";
import { LIST_ITEM_MARKER, MARGINS_BY_BLOCK_TYPE } from "../../constants";
import { nextListItemDepth } from "../../listItem";
import type { BriefBlock } from "../../schema";
import type { ListItemBlock } from "../../schema/blocks/list-item";
import Editable from "../components/Editable";
import BlockOptionsPanel from "../options/BlockOptionsPanel";
import ListItemOptions from "../options/ListItemOptions";
import { handleArrowNavigation } from "../utilities/navigation";
import type { BlockEditorProps } from "./types";

type ListItemBlockEditorProps = BlockEditorProps<ListItemBlock> & {
    listMarker: string;
    previousBlock: BriefBlock | undefined;
};

export default function ListItemBlockEditor(props: ListItemBlockEditorProps) {
    const { block, onChange, autoFocus, controls, listMarker, previousBlock } = props;
    return (
        <SpecialSupport
            enabled={OnMouseOver}
            content={
                <BlockOptionsPanel onInsert={controls.insertBlock} onRemove={controls.removeBlock}>
                    <ListItemOptions block={block} onChange={(next) => onChange(next)} />
                </BlockOptionsPanel>
            }
        >
            <Text
                variant="body"
                css={css(MARGINS_BY_BLOCK_TYPE[block.type], {
                    paddingInlineStart: `calc(${block.depth} * ${getSpaceVariable(6)})`,
                })}
            >
                <span aria-hidden css={LIST_ITEM_MARKER}>
                    {listMarker}
                </span>
                <Editable
                    mode="html"
                    value={block.html}
                    placeholder="Puce"
                    autoFocus={autoFocus}
                    onChange={(html) => onChange({ ...block, html })}
                    onEnter={controls.splitBlock}
                    onBackspace={() => {
                        if (block.depth > 0) {
                            onChange({ ...block, depth: block.depth - 1 });
                            return;
                        }
                        onChange({
                            id: block.id,
                            type: "body",
                            html: block.html,
                        });
                    }}
                    onKeyDown={(event) => {
                        if (event.key === "Tab") {
                            event.preventDefault();
                            const depth = nextListItemDepth(
                                block,
                                previousBlock,
                                event.shiftKey ? -1 : 1,
                            );
                            if (depth !== block.depth) onChange({ ...block, depth });
                            return;
                        }
                        if (handleArrowNavigation(event)) controls.closeOptions();
                    }}
                />
            </Text>
        </SpecialSupport>
    );
}
